import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export class Buckets {

  /**
   * Retrieves the buckets from a given project.
   * @param {number} id The project ID, from which the buckets should be retrieven.
   */
  static async load(id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/bucket/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          id: id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Retrieves a single bucket.
   * @param {number} project_id The project ID, where the bucket is located.
   * @param {number} bucket_id The bucket ID, which should be retrieved.
   */
  static async get(project_id, bucket_id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/bucket/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          id: project_id,
          bucket_id: bucket_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Creates a new bucket inside of a project.
   * @param {number} project_id Defines the project where the new bucket should be stored.
   * @param {string} name The new name of the bucket.
   */
  static async create(project_id, name){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/bucket/",
        method: "POST",
        data: {
          _console_token: UserSession.token,
          project: project_id,
          name: name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Updates an existing bucket.
   * @param {number} bucket_id The bucket ID, which should be updated.
   * @param {string} name The new name of the existing bucket.
   */
  static async edit(bucket_id, name) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/bucket/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          id: bucket_id,
          name: name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Deletes an existing bucket.
   * @param {number} bucket_id The bucket ID, which should be deleted.
   */
  static async delete(bucket_id) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/bucket/",
        method: "DELETE",
        data: {
          _console_token: UserSession.token,
          id: bucket_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }
}
